/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import template from './search-pagination.component.html';
import {ADMIN_LIST_IMPORTS} from '../admin-list-imports';
import {visiblePageNumbers} from './visible-page-numbers';

@Component({
  standalone: true,
  imports: ADMIN_LIST_IMPORTS,
  selector: 'adn-search-pagination',
  template
})
export class SearchPaginationComponent {
  @Input() page: any;
  @Input() searchMeta: any;

  totalPages(): number {
    return Math.max(1, Math.ceil((this.page?.totalHits || 0) / (this.searchMeta?.pageSize || 1)));
  }

  pageNumbers(): number[] {
    return visiblePageNumbers(this.searchMeta?.currentPage || 1, this.totalPages());
  }

  isLoading(): boolean {
    if (!this.searchMeta) {
      return false;
    }
    if (this.searchMeta.filterResolved === false) {
      return true;
    }
    return this.searchMeta.resolved === false;
  }

  changePage(page: number): void {
    if (!this.searchMeta || page < 1 || page > this.totalPages() || page === this.searchMeta.currentPage) {
      return;
    }
    this.searchMeta.currentPage = page;
    this.searchMeta.changePage();
  }
}
